import { render } from "./formsignature.vue?vue&type=template&id=40cd7c1c&scoped=true"
import script from "./formsignature.vue?vue&type=script&lang=js"
export * from "./formsignature.vue?vue&type=script&lang=js"

import "./formsignature.vue?vue&type=style&index=0&id=40cd7c1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40cd7c1c"]])

export default __exports__